import { getDocPath } from '../get-doc-path';
import { getCache } from './cache';
import { AddDocToCacheInput } from './interfaces';

export const addDocToCache = async ({ doc, Deserializer }: AddDocToCacheInput) => {
  const id = doc.getId();
  const cacheId = await getDocPath({ Deserializer, id });
  getCache().set(cacheId, doc);
};
